import { render, staticRenderFns } from "./ResetPasswordConfirm.vue?vue&type=template&id=29402d38"
import script from "./ResetPasswordConfirm.vue?vue&type=script&lang=js"
export * from "./ResetPasswordConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports